import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3em;
  padding: 0.8em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc((100% / 5) - 1em);
  height: 7.2em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color1};
  margin-left: 1em;

  ${props => {
    if (props?.index == 0) {
      return `margin-left: 0em;`;
    } else {
      return `margin-left: 1em;`;
    }
  }}

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .card-bottom {
    margin-top: 0em;
    margin-left: 0.8em;
    width: 100%;
    display: flex;
    flex-direction: row
    justify-content: center
    align-items: flex-start;

    .card-grupo {
      background: ${Colors.Color8};
      border-radius: 0.4em;
      padding: 0.2em 0.6em;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 1em;
      margin-right: 1em;

      .grupoperfil {
        font-size: 0.7em;
        font-weight: bold;
        color: ${Colors.Color4};
      }
    }
  }

  .card-numero {
    position: absolute;
    top: -1em;
    right: -1em;
    width: 7em;
    height: 7em;
    padding: 0.5em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    img {
      width: 5.5em;
      margin-bottom: 1.3em;
      margin-right: 1em;
    }
  }

  .card-body {
    margin-left: 0.8em;
    margin-top: 0.4em;
    width: 100%;

    .titulo {
      font-size: 0.7em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 95%;
      font-weight: 800;
      color: ${Colors.Color4};
    }

    .descricao {
      font-size: 0.8em;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      overflow: hidden;
      font-weight: 800;
      color: ${Colors.Color14};
    }

    .sub-descricao {
      font-size: 0.65em;
      font-weight: 500;
      color: ${Colors.Color14};
    }
  }
`;
